/**
 * Wording version of the on-air notice shown before entering a tournament
 * voice room. Must match `BROADCAST_CONSENT_VERSION` on the server: the accept
 * call carries the version that was actually displayed, and the server refuses
 * to record agreement to anything but the current one. Bump both together when
 * the text of `broadcastConsent.body` changes in a way that changes its meaning
 * — everyone is then asked again, which is the point.
 */
export const BROADCAST_CONSENT_VERSION = 1;
